import { DEVICES_FORWARDER_NAME, RETAIL_FORWARDER_NAME } from '.';

const partiesOnEquityInfusionModel: string[] = [
  DEVICES_FORWARDER_NAME,
  RETAIL_FORWARDER_NAME,
];

export const supportsEquityInfusionModel = (billToPartyName: string): boolean =>
  partiesOnEquityInfusionModel.includes(billToPartyName);
